// extracted by mini-css-extract-plugin
export default {"InfoField":"styles_InfoField__-LUaA","value":"styles_value__RsPEA","row":"styles_row__9T7vh"};